import React from 'react'

import { Flex, ResponsiveSVG } from 'ui/acro'
import { AppleStoreBadge } from 'images'

const DeviceBadges = () => (
  <Flex
    alignSelf={['stretch', null, 'center', 'start']}
    justifyContent='space-around'
    flexWrap={['wrap', 'nowrap']}
  >
    <ResponsiveSVG
      as='a'
      aria-label='Click here to download Alo Moves on the Apple App Store'
      className='unstyled'
      href='https://apps.apple.com/us/app/alo-moves/id601617403'
      target='_blank'
      rel='noopener noreferrer'
      id='home-ios'
      mr={[null, null, '25px']}
      width={['118px', '147px']}
      tabIndex={0}
      SVG={AppleStoreBadge}
    />
  </Flex>
)

export default DeviceBadges
